import React from 'react'
import { Redirect, useLocation, useParams } from 'react-router-dom'

import { Loader } from '../../components'
import { useApi } from '../../providers'
import { samePath, vendorPath } from '../../routes/links'

import { NotFoundPage } from '../not-found'

import { VendorPage } from './vendor'
import { VendorRouteParams } from './vendor.types'

export const VendorRoutePage = () => {
  const { id, vendorSlug } = useParams<VendorRouteParams>()
  const location = useLocation()
  const {
    vendor: { useVendor }
  } = useApi()
  const { data, loading } = useVendor(id ? { id } : { slug: vendorSlug || '' })

  if (loading) {
    return <Loader />
  }

  const vendor = data?.vendor

  if (!vendor) {
    return <NotFoundPage />
  }

  const pathname = vendorPath(vendor)

  if (!samePath(location.pathname, pathname)) {
    return <Redirect to={{ ...location, pathname }} />
  }

  return <VendorPage key={vendor.id} vendor={vendor} />
}
